import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import _ from "lodash";
import carYears from "../../utils/carYears";
import insuredValues from "../../utils/insuredValues";

import Input from "../../components/FormComponents/Input/Input";
import Modal from "react-bootstrap/Modal";
import Select from "../../components/FormComponents/Select/Select";
import TopBack from "../../components/Renewal/TopBack";
import { Link } from "react-scroll";

const Cars = (props) => {
	const {
		makeModels,
		productExceptionMessages
	} = props;

	const [showModal, setShowModal] = useState(false);

	//add car values
	const [vin, setVin] = useState("");
	const [carOwnership, setCarOwnership] = useState("");
	const [company, setCompany] = useState("");
	const [lienHolderStatus, setLienHolderStatus] = useState("");
	const [lienHolder, setLienHolder] = useState("");
	const [year, setYear] = useState("");
	const [make, setMake] = useState("");
	const [model, setModel] = useState("");
	const [insured, setInsured] = useState("");

	const [cars, setCars] = useState([]);
	const [models, setModels] = useState([]);
	const [carPosition, setCarPosition] = useState(0);

	const [showNewCar, setShowNewCar] = useState(false);

	const dispatch = useDispatch();
	let history = useHistory();

	const vinRef = useRef();
	const modelRef = useRef();
	const yearRef = useRef();
	const makeRef = useRef();
	const valueRef = useRef();
	const lienRef = useRef();
	const companyRef = useRef();

	const renewalData = useSelector((state) => state.RenewalData);
	const renewalId = useSelector((state) => state.RenewalId);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (makeModels) {
			let thisModels = JSON.parse(makeModels);
			thisModels = thisModels.map((model) => (
				<option value={model.make_name} key={model.id}>
					{model.make_name}
				</option>
			));
			setModels(thisModels);
		}
	}, [makeModels]);

	useEffect(() => {
		if (renewalData) {
			setCars(renewalData.cars);
		}
	}, [renewalData]);

	const handleHideModal = () => {
		setShowModal(false);
	};

	const handleShowModal = () => {
		setShowModal(true);
	};

	const carInsuredValuesOptions = insuredValues.insuredValues.map((value) => (
		<option value={value} key={value}>
			${numberWithCommas(value)}
		</option>
	));

	const carYearsOptions = carYears.carYears.map((year) => (
		<option value={year} key={year}>
			{year}
		</option>
	));

	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	const changeDeductible = (value, index) => {
		//let newCars = cars;
		let newCars = JSON.parse(JSON.stringify(cars));
		newCars[index] = { ...newCars[index], value: value };
		setCars([...newCars]);
		changeCars([...newCars]);
	};

	const removeCar = () => {
		//let array = cars;
		let array = JSON.parse(JSON.stringify(cars));
		array.splice(carPosition, 1);
		setCars(array);
		changeCars(array);
	};

	const saveCar = (e) => {
		e.preventDefault();

		if (!checkErrorsForm()) {
			const newCar = {
				vin: vin,
				year: year,
				make: make,
				car_model: model,
				value: insured,
				lienHolderStatus: lienHolderStatus,
				lienHolder: lienHolder,
				carOwnership: carOwnership,
				company: company,
			};
			setCars([...cars, newCar]);
			changeCars([...cars, newCar]);
			setShowNewCar(false);
		}
	};

	const checkErrorsForm = () => {
		let errors = false;
		let lienError = false;
		let companyError = false;

		const vinError = vinRef.current.validateInput();
		const modelError = modelRef.current.validateInput();

		const yearError = yearRef.current.validateSelect();
		const makeError = makeRef.current.validateSelect();
		const valueError = valueRef.current.validateSelect();

		if (lienHolderStatus == 1 || lienHolderStatus == 2) {
			lienError = lienRef.current.validateInput();
		}
		if (carOwnership == 1) {
			companyError = companyRef.current.validateInput();
		}

		if (vinError || modelError || yearError || makeError || valueError) {
			errors = true;
		} else {
			if (lienHolderStatus == 1 || lienHolderStatus == 2) {
				if (lienError) {
					errors = true;
				}
			}
			if (carOwnership == 1) {
				if (companyError) {
					errors = true;
				}
			}
		}

		return errors;
	};

	const changeCars = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, cars: value }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	return (
		<div className="cars d-flex justify-content-center general">
			<div className="otcontainer1 nopadding">
				<TopBack />
				<div className="">
					<div className="col">
						<h1 className="otmt-2" style={{ color: "#00778a" }}>
							My Vehicles
						</h1>
						<p className="otmt-2 otmb-2">
							Unlimited cars are included in your policy. Your base premium is
							determined by your most expensive car.
						</p>
					</div>
				</div>

				{cars.map((car, i) => {
					return (
						<div key={i} className="col">
							<div className="card mb-3">
								<div className="card-body col-12">
									<div className="row mx-auto">
										<h3
											className="col-8 col-md-10 otmt-1 mb-0 pl-0 pl-md-4"
											style={{ color: "#00778a" }}
										>
											{car.year} {car.make} {car.car_model}
										</h3>

										<div className="align-items-baseline d-flex ml-0 pl-0 pl-md-4">
											<p className="font-weight-bold text-uppercase">
												DEDUCTIBLE:
											</p>
											<p className="ml-2">
												$
												{numberWithCommas(
													(car.value * car.deductible_percentage) / 100
												)}{" "}
												({Math.round(car.deductible_percentage)}% of car value)
											</p>
										</div>

										<div className="mb-0 mt-3 otmb-1 pl-0 pl-md-4">
											<p
												htmlFor="formGroupExampleInput"
												className="col-12 pl-0 font-weight-bold text-uppercase"
											>
												INSURANCE VALUE
											</p>
											<select
												className="col col-md-7 form-control"
												defaultValue={car.value}
												onChange={(e) => changeDeductible(e.target.value, i)}
											>
												{carInsuredValuesOptions}
											</select>
										</div>
										{cars.length === 1 ? null : (
											<div className="otmb-1 otmt-1 pl-0 pl-md-4">
												<p
													type="button"
													className="mb-0"
													style={{ color: "red" }}
													onClick={() => {
														setCarPosition(i);
														handleShowModal();
													}}
												>
													<u>Remove this vehicle</u>
												</p>
											</div>
										)}
									</div>
								</div>
							</div>
							<div id="carform"></div>
						</div>
					);
				})}
				{showNewCar && (
					<div id="carForm" className="col">
						<div className="card mb-5">
							<div className="card-body col-11 mx-auto ">
								<div className="row ">
									<div className="col-10 col-md-5 pl-0">
										<h1
											className="pl-0 otmt-1 ml-md-0"
											style={{ color: "#00778a" }}
										>
											Add a vehicle
										</h1>
									</div>
									<div className="col-2 mt-2 col-md-7 d-md-flex justify-content-md-end pr-0">
										<i
											className="bi bi-x "
											onClick={() => setShowNewCar(false)}
										></i>
									</div>
								</div>
								<form onSubmit={(e) => saveCar(e)}>
									<div className="row">
										<h5 className="otmt-2 pl-0 mb-0">
											VEHICLE IDENTIFICATION NUMBER (VIN)
										</h5>
										<Input
											val={vin}
											setVal={setVin}
											classInput="form-control mb-md-3"
											validation="vin"
											ref={vinRef}
										/>
										<fieldset id="group1" className="pl-0">
											<h5 className="mt-4 pl-0">IS THERE A LIEN HOLDER?</h5>
											<div className="">
												<input
													required
													className="ml-2"
													type="radio"
													name="group1"
													id="option1"
													key={0}
													onClick={() => setLienHolderStatus(0)}
												/>
												<label
													htmlFor="option1"
													className=""
													style={{ fontSize: "24px" }}
												>
													<p className="mt-3 radio">
														No, the car is owned outright (there is not a lien
														holder)
													</p>
												</label>
											</div>
											<div className="">
												<input
													required
													className="ml-2"
													type="radio"
													name="group1"
													id="option2"
													key={1}
													onClick={() => setLienHolderStatus(1)}
												/>
												<label
													htmlFor="option2"
													className=""
													style={{ fontSize: "24px" }}
												>
													<p className="mt-3 radio">Yes, the car is leased</p>
												</label>
											</div>
											<div className="">
												<input
													required
													className="ml-2"
													type="radio"
													name="group1"
													id="option3"
													key={2}
													onClick={() => setLienHolderStatus(2)}
												/>
												<label
													htmlFor="option3"
													className=""
													style={{ fontSize: "24px" }}
												>
													<p className="mt-3 radio">Yes, the car is financed</p>
												</label>
											</div>
										</fieldset>

										{(lienHolderStatus == 1 || lienHolderStatus == 2) && (
											<>
												<h5 className="mt-4 pl-0">LIEN HOLDER NAME</h5>
												<Input
													val={lienHolder}
													setVal={setLienHolder}
													classInput="form-control mb-md-3"
													validation="lien"
													ref={lienRef}
												/>
											</>
										)}
										<fieldset id="group2" className="pl-0">
											<h5 className="mt-4 pl-0">WHO OWNS THE CAR?</h5>
											<div className="">
												<input
													required
													className="ml-2"
													type="radio"
													name="group2"
													id="option4"
													key={0}
													onClick={() => setCarOwnership(0)}
												/>
												<label
													htmlFor="option4"
													className=""
													style={{ fontSize: "24px" }}
												>
													<p className="mt-3 radio">An Individual</p>
												</label>
											</div>
											<div className="	">
												<input
													required
													className="ml-2"
													type="radio"
													name="group2"
													id="option5"
													key={1}
													onClick={() => setCarOwnership(1)}
												/>
												<label
													htmlFor="option5"
													className=""
													style={{ fontSize: "24px" }}
												>
													<p className="mt-3 radio">A Company</p>
												</label>
											</div>
										</fieldset>

										{carOwnership == 1 && (
											<>
												<h5 className="mt-4 pl-0">NAME OF THE COMPANY</h5>
												<Input
													val={company}
													setVal={setCompany}
													classInput="form-control mb-md-3"
													validation="company"
													ref={companyRef}
												/>
											</>
										)}
										<h5 className="mt-4 pl-0 mb-0">YEAR</h5>
										<Select
											val={year}
											setVal={setYear}
											label="YEAR"
											classLabel="d-none"
											options={carYearsOptions}
											selectLabel="Select Year"
											classSelect="form-control"
											validation="year"
											ref={yearRef}
										/>
										<h5 className="mt-4 pl-0 mb-0">MAKE</h5>
										<Select
											val={make}
											setVal={setMake}
											selectLabel="Select Make"
											options={models}
											classSelect="form-control"
											validation="make"
											ref={makeRef}
											productExceptionMessages={productExceptionMessages}
										/>
										<h5 className="mt-4 pl-0 mb-0">MODEL</h5>
										<Input
											val={model}
											placeholder="Model"
											setVal={setModel}
											classInput="form-control mb-md-3"
											validation="model"
											ref={modelRef}
										/>
										<h5 className="mt-4 pl-0">INSURED VALUE</h5>
										<p className="col-md-6 pl-0">
											Please enter an accurate value. Insured value determines
											the most you will be paid in the incident of a total loss
											(less your deductible).
										</p>
										<Select
											val={insured}
											setVal={setInsured}
											options={carInsuredValuesOptions}
											selectLabel="Select Value"
											classSelect="form-control"
											validation="value"
											ref={valueRef}
										/>
									</div>
									<div className="row">
										<div className="d-md-flex justify-content-md-end otmb-1">
											<div className="mr-md-4 otmt-2">
												<button
													type="button"
													className="col-12 btn btn1 btn-lg"
													onClick={() => setShowNewCar(false)}
												>
													CANCEL
												</button>
											</div>
											<div className="otmt-2">
												<button
													type="submit"
													className="col-12 btn btn2 btn-lg"
													style={{ minWidth: "160px" }}
												>
													ADD VEHICLE
												</button>
											</div>
										</div>
									</div>
									{/* <div className="row">
										<div className="col-12 d-md-flex justify-content-md-center">
											<div className="col-12  col-md-4 my-5">
												<button
													type="submit"
													className="col-12 btn btn2 btn-lg col-md-12"
												>
													ADD car
												</button>
											</div>
										</div>
									</div> */}
								</form>
							</div>
						</div>
					</div>
				)}
				<div className="d-flex justify-content-center otmb-4 otmt-2">
					{!showNewCar && (
						<Link
							to="carform"
							spy={true}
							smooth={true}
							ignoreCancelEvents
							className="mr-4"
						>
							<div className="">
								<button
									type="button"
									id="carBtn"
									className="btn btn1"
									onClick={() => {
										setVin("");
										setYear("");
										setMake("");
										setModel("");
										setInsured("");
										setShowNewCar(true);
									}}
								>
									ADD A VEHICLE
								</button>
							</div>
						</Link>
					)}

					<div className="">
						<button
							className="btn btn-lg btn2"
							onClick={() => history.goBack()}
						>
							SAVE AND EXIT
						</button>
					</div>
				</div>
			</div>

			<Modal
				className="cars-modal mx-auto"
				show={showModal}
				onHide={handleHideModal}
				centered
			>
				<div className="container">
					<div className="row justify-content-md-center mx-auto pr-5">
						<div className="col-12 mt-4">
							<p className="t4">Are you sure you want to remove this car?</p>
						</div>
					</div>

					<Modal.Footer>
						<div className="d-flex justify-content-between mt-4">
							<div className="col-5">
								<button onClick={handleHideModal} className="btn btn1">
									CANCEL
								</button>
							</div>
							<div className=" ">
								<button
									onClick={() => {
										removeCar();
										handleHideModal();
									}}
									className="btn btn2"
								>
									CONFIRM REMOVAL
								</button>
							</div>
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</div>
	);
};

export default Cars;
